// extracted by mini-css-extract-plugin
module.exports = {"separator":"event-page_separator__2oXIa","blocActu":"event-page_blocActu__qTHD6"};